<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<!-- MOC-3440 - Prevent negative input -->
<div class="wrap-relative">
	<error-pin
		class="l-drop-error-top-right"
		[messageHeader]="(errorState | async)?.messageHeader"
		[message]="(errorState | async)?.message"
		*ngIf="showErrorPin"
	></error-pin>
	<mat-form-field autocomplete="off" class="tiny-ticket-crew">
		<mat-label>Crew</mat-label>
		<input
			matInput
			novalidate
			disallowInput="^[0-9]*(\.[0-9]*)?$"
			type="number"
			[min]="validationData['liveCrewSize'].min"
			[max]="validationData['liveCrewSize'].max"
			step="1.0"
			[formControl]="internalField"
			(focus)="internalFocused()"
			(blur)="internalBlurred()"
		/>
	</mat-form-field>
</div>
